import styled, { css } from 'styled-components';
import colors from './colors';

import { PrimaryButton } from 'components/Buttons';
import { IconButtonStyle } from 'styles/buttons';

export const MENU_HEIGHT = '50px';
export const HEADER_HEIGHT = '70px';
export const FOOTER_HEIGHT = '70px';

export const fontWeight = {
  bold: 700,
  semibold: 600,
  regular: 500,
  light: 400,
};

export const RIGHT_SHADOW_BORDER_RULE = `
    box-shadow: 2px -1px 4px -2px ${colors.shadowBorder};
`;

export const SHADOW_BORDER_RULE = `
    box-shadow: 0 2px 4px 0 ${colors.shadowBorder};
`;

export const DEFAULT_BORDER_RADIUS = css`
  border-radius: 4px;
`;

export const Hidden = styled.div`
  display: none;
`;

export const AppWrapper = styled.div`
  flex: 1 0 auto;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: calc(100vh - env(safe-area-inset-bottom, 0) - env(safe-area-inset-top, 0));
  margin: 0 auto;
`;

export const Container = styled.div<{ menuVisible?: boolean }>`
  color: ${colors.black};
  background-color: ${colors.white};
  flex: 1 0 auto;
  position: relative;
  display: flex;
  flex-direction: column;

  ${({ menuVisible }) => Boolean(menuVisible) && `padding-top: 50px;`};
`;

export const PageContent = styled.div`
  padding: 0 20px;
`;

export const TableHeader = styled.header`
  display: flex;
  justify-content: space-between;
  width: 100%;
  text-transform: uppercase;
  margin-bottom: 1em;
`;

export const StyledPrimaryButton = styled(PrimaryButton)``;

export const Clearfix = styled.div`
  clear: both;
`;

export const Center = styled.div`
  text-align: center;
  height: 100%;
`;

export const ContentContainer = styled.div`
  display: flex;
`;

export const CardListContent = styled.div`
  padding-top: 22px;
  padding-bottom: 49px;
  width: 100%;
  max-width: 1280px;
  display: flex;
  align-items: center;
  flex-direction: column;
`;

export const EmptyStateHeader = styled.h5`
  font-weight: normal;
  margin-top: 0em;
  color: ${colors.inactive};
`;

export const FieldTitle = styled.h4<{ required?: boolean }>`
  align-items: center;
  flex-direction: row;
  font-size: 12px;
  line-height: 15px;
  margin-bottom: 5px;
  margin-top: 0;
  font-weight: normal;
  color: ${colors.fieldLabel};
  display: flex;
  position: relative;

  ${(props) =>
    props.required === true &&
    `
      & span::after {
        content: '*';
        padding-left: 0.25em;
        color: red;
      }
    `};

  ${IconButtonStyle} {
    font-size: 0.9em;
    height: 11px;
    line-height: 0.9em;
  }

  &[disabled] {
    color: ${colors.disabledText};
  }
`;

export const NoResults = styled.h3`
  font-weight: 600;
  text-align: center;
`;

export const Tag = styled.div<{ color?: string }>`
  margin-left: 3px;
  background-color: ${(props) => (props.color ? props.color : colors.green)};
  color: ${colors.white};
  border-radius: 2px;
  height: 16px;
  font-size: 10px;
  line-height: 12px;
  font-weight: 700;
  padding: 2px 4px;
  text-transform: uppercase;
`;

export const OutsideLink = styled.a`
  font-size: 12px;
  font-weight: 600;
`;
